export default __webpack_public_path__ + "static/media/Abhishek.018f363c.png";